// The console ships with a CSP without unsafe-eval (infra/maximus/console/Caddyfile): zod must not probe for
// `new Function` — the probe is caught, but every page load would still raise a CSP violation (and a report).
// Imported first by main.tsx so it runs before any schema is parsed.
import { z } from "zod";

z.config({ jitless: true });
